export default "__VITE_ASSET__$Mw7Ld8i__"